<template>
  <div class="fm-file-select mb-2">
    <b-media class="w-100">
      <template v-if="!hidePreview" #aside>
        <b-avatar
            v-if="type === 'img'"
            :src="value"
            size="90px"
            rounded
        />
        <b-avatar
            v-else-if="type === 'video'"
            size="90px"
            rounded
            button
            @click="showModal = true"
        >
          <feather-icon icon="PlayCircleIcon" size="35" />
        </b-avatar>
      </template>

      <b-form-group
          :label="label"
          class="mb-0 input"
      >
        <b-form-input
            id="file"
            :value="value"
            autocomplete="off"
            dir="ltr"
            readonly
            @focus="focus"
        />
        <feather-icon
            v-if="selfValue"
            icon="XIcon"
            class="clear-btn"
            @click="selfValue = ''"
        />
      </b-form-group>
    </b-media>

    <b-modal
        v-model="showModal"
        title="نمایش ویدئو"
        hide-footer
        centered
    >
      <div class="d-flex justify-content-center">
        <video
            style="border-radius: 0.357rem;"
            height="250"
            controls
        >
          <source :src="value">
        </video>
      </div>
    </b-modal>

    <file-manager-modal
        v-if="visible"
        v-model="selfValue"
        :show.sync="visible"
        :entity="entity"
        :selectable="selectable"
        :editable="editable"
    />
  </div>
</template>

<script>
import FileManagerModal from "@/views/menu/file-manager/components/fileManagerModal.vue";

export default {
  name: "fmFileSelect",
  components: { FileManagerModal },
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    entity: { type: [String, Number], default: 0 },
    selectable: { type: Boolean, default: true },
    editable: { type: Boolean, default: true },
    hidePreview: { type: Boolean, default: false },
    type: { type: String, default: 'img' },
  },
  data() {
    return {
      visible: false,
      showModal: false
    }
  },
  computed: {
    selfValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    }
  },
  methods: {
    focus() {
      this.visible = true
    }
  }
}
</script>

<style lang="scss">
.fm-file-select {
  display: flex;
  //flex-wrap: wrap;
  .form-control {
    padding-left: 35px;
  }
  .form-control[readonly] {
    background-color: inherit;
    width: 100%;
  }
  .input {
    position: relative;
  }
  .media {
    align-items: flex-end;
  }
  .clear-btn {
    background-color: #ececec;
    width: 20px;
    height: 20px;
    padding: 3px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translate(0, -50%) !important;
    cursor: pointer;
  }
}
</style>